(function() {
    var filtersAreDisabled = false;
    var steps = $('.steps__title');
    var stepsOptions = $('.stepOptions__option');
    var additionalFilters = $('.additionalFilters__title');
    var additionalFiltersOption = $('.additionalFilters__option');
    let locales = getLang();
    let priceFilter = $('#aside-filter-price-range');

    steps.on('click', switchStep);
    stepsOptions.on('click', selectOption);
    additionalFiltersOption.on('click', selectAdditionalOption);
    additionalFilters.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var additionalFiltersOptions = $(this).parent().find('.additionalFilters__options');
        var isCurrentOptionsBoxHidden = additionalFiltersOptions.hasClass('--hidden');
        $('.additionalFilters .additionalFilters__options').addClass('--hidden');
        if (isCurrentOptionsBoxHidden) {
            additionalFiltersOptions.removeClass('--hidden');
        } else {
            additionalFiltersOptions.addClass('--hidden');
        }
    });
    $('.stepOptions__series-details-toggle').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $('.stepOptions__series-details').toggleClass('--hidden');
        $('.stepOptions__series-details-toggle i').toggleClass('fa-caret-up');
    });

    $('.products__loadMoreProducts').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        filterProducts(true);
    });

    $('.products__filter-option-link[data-type], .multi-select-link[data-type]').click(function(e) {
        e.stopPropagation();
        if (filtersAreDisabled) {
            e.preventDefault();
            return false;
        }
        disableMenuElemClick();

        const input = $(this).find(`input[type="checkbox"],input[type="radio"]`);

        if (input.not(':checked').length) {
            input.prop('checked', true).change();
        } else {
            input.prop('checked', false).change();
        }

        processAsideConditionSwitch(
            $(this).data('type'),
            $(this).data('slug')
        );
    })

    $(".dropdown-menu-form input:checkbox, .dropdown-menu-form input:radio").click(function(e) {
        e.stopPropagation();
        if (filtersAreDisabled) {
            e.preventDefault();
            return false;
        }
        disableMenuElemClick();
        processAsideConditionSwitch(
            $(this).parent().parent().parent().data('type'),
            $(this).parent().parent().parent().data('slug')
        );
    })

    function disableMenuElemClick() {
        filtersAreDisabled = true;
        // $('li.multi-select-link[data-type]').children().bind('click', function(){ return false; });
        // $('li.multi-select-link input[type="checkbox"]').bind('click', function(){ return false; });
        // $('li.multi-select-link input[type="radio"]').bind('click', function(){ return false; });
    }

    function switchStep() {
        event.preventDefault();
        $('.steps__title').removeClass('--selected');
        $('.stepOptions__wrapper').addClass('--hidden');

        $(this).addClass('--selected');
        $('.stepOptions__wrapper[data-parent-step-id="' + $(this).data('stepId') + '"]').removeClass('--hidden');
    }

    function selectOption(e) {
        e.preventDefault();
        if ($(this).hasClass('--selected')) {
            $(this).removeClass('--selected');
        } else {
            const type = $(this).data('type');
            $('[data-type="' + type + '"]').removeClass('--selected');
            $(this).addClass('--selected');
        }
        resetAllNextOptions($(this));
        filterProducts(false, false)
    }

    function selectAdditionalOption() {
        event.preventDefault();
        event.stopPropagation();
        $(this).parent().find('.--selected').removeClass('--selected');
        $(this).addClass('--selected');
        filterProducts(false)
    }

    // in main steps we want to reset next steps after choose the previous one
    // and also we want to reset additional filters
    function resetAllNextOptions(selectedOption) {
        var currentStep = selectedOption.parent().data('parentStepId');
        var allSteps = $('[data-parent-step-id]');

        $.each(allSteps, function(index, step) {
            if ($(step).data('parentStepId') > currentStep) {
                $(step).find('.--selected').removeClass('--selected');
            }
        });

        $('.additionalFilters__option').removeClass('--selected');
    }

    function getShopNowUrl() {
        if (isAsideMenu()) {
            if (isBundles()) {
                return locales.BUNDLES_TEST_URL;
            }
            if (isBundlesAndProducts()) {
                return locales.BUNDLES_AND_PRODUCTS_TEST_URL;
            }
            return locales.SHOP_NOW_TEST_URL;
        }
        if (isBundles()) {
            return locales.BUNDLES_URL;
        }

        // if (isBundlesAndProducts()) {
        //     return locales.BUNDLES_AND_PRODUCTS_URL;
        // }

        return locales.SHOP_NOW_URL;
    }

    function isAsideMenu() {
        return $('.products__filters').length > 0;
    }

    function isBundles() {
        return $('div#bundles-indicator').length > 0;
    }

    function isBundlesAndProducts() {
        return $('div#bundles-and-products-indicator').length > 0;
    }

    function filterProducts(loadMore) {

        var params = {};
        var url = "";
        if (isAsideMenu()) {
            params = getAsideParamsValues(loadMore);
            url = getAsideUrl(params);
        } else {
            params = getParamsValues(loadMore);
            url = buildUrl(params);
        }

        var headers = { 'filterRequest': true };

        if (loadMore) {
            headers.loadMore = true;
            $('.products__loadMoreProductsTitle').hide();
            $('.products__loadMoreProductsReloadIcon').addClass('--active');
            $.ajax({
                url: '/' + getShopNowUrl() + url,
                headers: headers,
                success: function(response) {
                    if (loadMore) {
                        $('.search-pagination').remove();
                        $('.products__container_inner').append(response.products);
                        setPriceSwitchState();

                        if (response.hasMoreProducts) {
                            $('.products__loadMoreProducts').removeClass('--hidden');
                        } else {
                            $('.products__loadMoreProducts').addClass('--hidden');
                        }
                        observer.observe();

                        $('.products__loadMoreProductsTitle').show();
                        $('.products__loadMoreProductsReloadIcon').removeClass('--active');

                        return true;
                    }
                }
            });
        } else {
            document.location.assign('/' + getShopNowUrl() + url);
        }
    }

    function processAsideConditionSwitch(filterName, filterSlug = '') {
        let filters = getAsideParamsValues();
        if (filters[filterName] != undefined) {
            if (filters[filterName]['clearOthers']) {
                filters = Object.keys(filters)
                    .filter(key => {
                        return [filterName].includes(key);
                    })
                    .reduce((obj, key) => {
                        obj[key] = filters[key];
                        return obj;
                    }, {});
            }

            if (filters[filterName]['type'] == 'array') {
                if (filterSlug === "") {
                    filters[filterName]['values'] = [];
                } else {
                    if (filters[filterName]['values'].includes(filterSlug)) {
                        filters[filterName]['values'] = filters[filterName]['values'].filter(e => e !== filterSlug)
                    } else {
                        filters[filterName]['values'].push(filterSlug)
                    }
                }
            }
            if (filters[filterName]['type'] == 'singleValue') {
                filters[filterName]['value'] = filterSlug;
            }
        }

        const url = getAsideUrl(filters);

        setTimeout(function() {
            document.location.assign('/' + getShopNowUrl() + url);
        }, 100);

    }
    function getAsideUrl(filters)
    {
        let urlParams = []
        let urlSuffixBase = "";
        for(let filter in filters) {
            if (filters[filter]['type'] === 'singleValue' && filters[filter]['value'] !== "") {
                urlSuffixBase += '/' + encodeURIComponent(filters[filter]['value']);
            }
            if (filters[filter]['type'] === 'array') {
                if (filters[filter]['values'].length > 1) {
                    urlParams.push(
                        filters[filter]['values'].map((value, index) => `${filter}[${index}]=${encodeURIComponent(value)}`).join('&')
                    )
                } else if(filters[filter]['values'].length === 1) {
                    // urlParams.push(`${filter}=${encodeURIComponent(filters[filter]['values'][0])}`)
                    urlSuffixBase += '/' + encodeURIComponent(filters[filter]['values'][0]);
                }
            }
            if (filters[filter]['type'] === 'range') {
                if (filters[filter]['values']['min'] != null) {
                    urlParams.push(`${filter}-min=${encodeURIComponent(filters[filter]['values']['min'])}`);
                }
                if (filters[filter]['values']['max'] != null) {
                    urlParams.push(`${filter}-max=${encodeURIComponent(filters[filter]['values']['max'])}`);
                }
            }
            if (filters[filter]['type'] === 'simple') {
                urlParams.push(`${filter}=${encodeURIComponent(filters[filter]['values'])}`);
            }
        }
        let urlSuffix = ""
        if (urlParams.length > 0) {
            urlSuffix = "?" + urlParams.join("&")
        }

        return urlSuffixBase + urlSuffix;
    }
    function getAsideParamsValues(loadMore = false) {
        let params = {};
        let singleValueParamNames = ['category'];
        let clearAllOtherFilters = ['category'];
        let arrayParamNames = ['material', 'type', 'serier', 'glazing'];

        for(let paramName of singleValueParamNames) {
            params[paramName] = {
                'type':'singleValue',
                'clearOthers': clearAllOtherFilters.indexOf(paramName) != -1,
                'value': getAsideSingleValParamValue(paramName)
            }
        }

        for(let paramName of arrayParamNames) {
            params[paramName] = {
                'type':'array',
                'clearOthers': clearAllOtherFilters.indexOf(paramName) != -1,
                'values': getAsideParamValues(paramName)
            }
        }

        let rangeParamNames = ['price'];
        for(let paramName of rangeParamNames) {
            const rangeData = getAsideRangeParamValues(paramName);
            if (rangeData.min < rangeData.val[0] || rangeData.max > rangeData.val[1]) {
                const rangeValues = { min: null, max: null};
                if (rangeData.min < rangeData.val[0]) {
                    rangeValues.min = rangeData.val[0];
                }
                if (rangeData.max > rangeData.val[1]) {
                    rangeValues.max = rangeData.val[1];
                }
                params[paramName] = {
                    'type':'range',
                    'clearOthers': clearAllOtherFilters.indexOf(paramName) != -1,
                    'values': rangeValues
                }
            }
        }

        if (loadMore) {
            var currentPage = $('#page-number-container').data('page');
            currentPage === '' ? currentPage = 2 : currentPage++;
            $('#page-number-container').data('page', currentPage);
            params.page = {
                'type': 'simple',
                'clearOthers': false,
                'values': currentPage
            };
        } else {
            $('#page-number-container').data('page', 1);
        }

        let sort = $('.--selected[data-type="sort"]');
        if (sort.length > 0 && sort.data('slug') !== '') {
            params.sort = {
                'type': 'simple',
                'clearOthers': false,
                'values': sort.data('slug')
            };
        }

        params.sort = {
            'type': 'simple',
            'clearOthers': false,
            'values': getAsideSingleValParamValue2('sort')
        }

        return params;
    }
    function getAsideParamValues(paramName) {
        const values = [];
        $(`.multi-select-link[data-type="${paramName}"] input[checked]`).each(function() {
            const dataElem = $(this).parent().parent().parent();
            if (dataElem.data('slug') !== "") {
                values.push(dataElem.data('slug'))
            }
        });

        return values;
    }

    function getAsideSingleValParamValue2(paramName) {
        let value = "";
        $(`.multi-select-link[data-type="${paramName}"] input[name=${paramName}]:checked`).each(function() {
            const dataElem = $(this).parent().parent().parent();
            if (dataElem.data('slug') !== "") {
                value = dataElem.data('slug');
            }
        });

        return value;
    }

    function getAsideSingleValParamValue(paramName) {
        let value = "";
        $(`.--selected[data-type="${paramName}"]`).each(function() {
            if ($(this).data('slug') !== "") {
                value = $(this).data('slug');
            }
        });

        return value;
    }

    function getAsideRangeParamValues(paramName)
    {
        return {
            val: $(`#aside-filter-${paramName}-range`).val().split(","),
            min: $(`#aside-filter-${paramName}-range`).data('slider-min'),
            max: $(`#aside-filter-${paramName}-range`).data('slider-max'),
        }
    }

    function getParamsValues(loadMore) {
        // we divide parameters into two groups: basic (used for pretty urls) and additional (used for query params, sorting)
        // we dont want index urls with additional params
        var params = { main: {}, additional: {} };
        var currentPage = $('#page-number-container').data('page');

        var selectedCategory = $('.--selected[data-type="category"]');
        var selectedMaterial = $('.--selected[data-type="material"]');
        var selectedType = $('.--selected[data-type="type"]');
        var selectedSerie = $('.--selected[data-type="serie"]');

        var selectedGlass = $('.--selected[data-type="glass"]');
        var selectedFactory = $('.--selected[data-type="factory"]');

        var sort = $('.--selected[data-type="sort"]');

        selectedCategory.length > 0 ? params.main.category = selectedCategory.data('slug') : false;
        selectedMaterial.length > 0 ? params.main.material = selectedMaterial.data('slug') : false;
        selectedType.length > 0 ? params.main.type = selectedType.data('slug') : false;
        selectedSerie.length > 0 ? params.additional.serier = selectedSerie.data('slug') : false;

        selectedGlass.length > 0 && selectedGlass.data('slug') !== '' ? params.main.glass = selectedGlass.data('slug') : false;
        selectedFactory.length > 0 && selectedFactory.data('slug') !== '' ? params.additional.varumarke = selectedFactory.data('slug') : false;
        sort.length > 0 && sort.data('slug') !== '' ? params.additional.sort = sort.data('slug') : false;

        if (loadMore) {
            currentPage === '' ? currentPage = 2 : currentPage++;
            $('#page-number-container').data('page', currentPage);
            params.additional.page = currentPage;
        } else {
            $('#page-number-container').data('page', 1);
        }

        return params;
    }

    function buildUrl(params) {
        var prefix = '';
        var suffix = '';

        // I  could use loop here but I want exactly that order of main parameters
        if (params.main.category) {
            prefix += '/' + params.main.category;
        }
        if (params.main.material) {
            prefix += '/' + params.main.material;
        }
        if (params.main.type) {
            prefix += '/' + params.main.type;
        }
        if (params.main.glass) {
            prefix += '/' + params.main.glass;
        }
        if (params.main.page) {
            prefix += '/' + params.main.page;
        }

        for (var param in params.additional) {
            suffix += '&' + param + '=' + params.additional[param];
        }

        if (suffix !== '') {
            suffix = '?' + suffix.substr(1);
        }

        return prefix + suffix;
    }

    if (typeof priceFilter.bootstrapSlider === 'function') {
        priceFilter.bootstrapSlider();
    }

    priceFilter.on('change', function(e) {
        processAsideConditionSwitch('price');
    })

    $(".dropdown-menu").on('click', function(e) {
        if ($(this).hasClass('dropdown-menu-form')) {
            e.stopPropagation();
        }
    });
    $(".dropdown-menu-form").on('click', function(e) {
        e.stopPropagation();
    });

    $(".products__filter-multiple-search[data-type] input").on('input', function(e) {
        const dataType = $(this).parent().data('type');
        const searchedText = $(this).val();
        $(`.dropdown-menu-form li.multi-select-link[data-type='${dataType}']`).each(function(elem) {
            if (searchedText == '' || $(this).data('title').indexOf(searchedText) > -1) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    })

})()
